import { render, staticRenderFns } from "./FormBicTransfer.vue?vue&type=template&id=b3e0cbb6&scoped=true&lang=html&"
import script from "./FormBicTransfer.vue?vue&type=script&lang=js&"
export * from "./FormBicTransfer.vue?vue&type=script&lang=js&"
import style0 from "./FormBicTransfer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./FormBicTransfer.vue?vue&type=style&index=1&id=b3e0cbb6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e0cbb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VBtn,VCardActions,VCheckbox,VCol,VContainer,VForm,VRow,VSpacer})
